import { Cancel } from '@material-ui/icons';
import { Avatar, Card, CardContent, Grid, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

export const ConfirmedLinesCard = props => {
  const { cards } = useSelector(state => state.dashboard);
  return (
    <Card {...props}>
      <CardContent sx={{ minHeight: 140 }}>
        <Grid container spacing={3} sx={{ justifyContent: 'space-between' }}>
          <Grid item>
            <Typography color="textSecondary" gutterBottom variant="overline">
              Número de Líneas Pendientes de Confirmar
            </Typography>
            <Typography color="textPrimary" variant="h4">
              {cards?.NumeroLineasPendientesConfirmar}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar
              sx={{
                backgroundColor: 'error.main',
                height: 56,
                width: 56,
              }}>
              <Cancel />
            </Avatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
